import clsx from "clsx";
import { Plus, Time } from "components/Icons";
import { AnimatePresence, motion } from "framer-motion";
import { useStores } from "hooks/useStores";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

const TimerButton = observer(
  ({ recipeId, stepId, heading, minutes, isDisabled }) => {
    const { timerStore } = useStores();

    const [isHovering, setIsHovering] = useState(false);

    const handleAddTimer = () => {
      timerStore.addTimer(recipeId, stepId, heading, minutes, true);
    };

    const className = clsx("TimerButton", {
      "TimerButton--isDisabled": isDisabled,
    });

    return (
      <div className={className}>
        <AnimatePresence>
          {isHovering && (
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              className="TimerButton__label"
            >
              Start a timer for {minutes} minutes
            </motion.div>
          )}
        </AnimatePresence>
        <Button
          handleAddTimer={handleAddTimer}
          isDisabled={isDisabled}
          isHovering={isHovering}
          setIsHovering={setIsHovering}
        />
      </div>
    );
  }
);

const Button = ({ handleAddTimer, isDisabled, isHovering, setIsHovering }) => {
  const [isIconAnimating, setIsIconAnimating] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  // On mount and if not hovering, apply animation
  useEffect(() => {
    if (isDisabled) return;

    setIsIconAnimating(true);

    const iconAnimatingTimer = setTimeout(
      () => setIsIconAnimating(false),
      2250
    );

    return () => {
      clearTimeout(iconAnimatingTimer);
    };
  }, [isDisabled]);

  const iconClassName = clsx("TimerButton__icon", {
    "TimerButton__icon--isAnimating": !isHovering && isIconAnimating,
  });

  return (
    <button
      onClick={handleAddTimer}
      className="TimerButton__button"
      disabled={isDisabled}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      type="button"
    >
      <div className={iconClassName}>
        {isHovering && <Plus />}
        {!isHovering && <Time />}
      </div>
    </button>
  );
};

export default TimerButton;
